import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=9691d52c"
import script from "./RoleSelector.vue?vue&type=script&lang=js"
export * from "./RoleSelector.vue?vue&type=script&lang=js"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=9691d52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports